import validate from "/src/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@11.10.0_db0@0.3.2_253ed81903c9eb8ad92cd4f5f877e0e9/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45moved_45permanently_45redirection_45global from "/src/app/middleware/01.moved-permanently-redirection.global.ts";
import _02_45unauthorized_45redirection_45global from "/src/app/middleware/02.unauthorized-redirection.global.ts";
import manifest_45route_45rule from "/src/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@11.10.0_db0@0.3.2_253ed81903c9eb8ad92cd4f5f877e0e9/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45moved_45permanently_45redirection_45global,
  _02_45unauthorized_45redirection_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "handle-legacy-business-slug": () => import("/src/app/middleware/handle-legacy-business-slug.ts")
}